var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex align-center px-5 py-3",attrs:{"color":"var(--kaki)","elevation":"0"}},[_c('div',{staticClass:"action --text-kaki-fonce"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }